export const CONTACT_INFO = {
  phone: "+91 8796 41 8282",
  phoneHref: "tel:+918796418282",
  whatsapp: "+91 8796 41 8282",
  whatsappHref: "https://wa.me/918796418282",
  email: "admin@bookmysquadd.com",
  supportEmail: "support@bookmysquadd.com",
  salesEmail: "sales@bookmysquadd.com",
  location: "Gurugram, India",
  workingHours: "Mon–Sat, 10am–7pm IST",
} as const;
